const NAME = 'BUGSNAG';
const CNameMapping = {
  [NAME]: NAME,
  bugsnag: NAME,
  Bugsnag: NAME,
};

export { NAME, CNameMapping };
